// /health probes — no auth, no CORS-credentialed (the response is just "Healthy" text).

export async function pingHealth(baseUrl: string, signal?: AbortSignal): Promise<boolean> {
  try {
    const r = await fetch(`${baseUrl}/health`, { signal });
    return r.ok;
  } catch {
    return false;
  }
}
